import { render } from "./EventsListWordcloud.vue?vue&type=template&id=6791a9f3&scoped=true"
import script from "./EventsListWordcloud.vue?vue&type=script&lang=js"
export * from "./EventsListWordcloud.vue?vue&type=script&lang=js"

import "./EventsListWordcloud.vue?vue&type=style&index=0&id=6791a9f3&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6791a9f3"]])

export default __exports__